import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import axios from "axios"
import moment from 'moment-timezone'
import httpUtils from '@/utils/http-utils';

import contacts from './modules/contacts'
// import OldPurchaseOrders from './modules/purchase-orders'

import salesOrderEditor from './modules/salesOrderEditor'
import controlData from './modules/controlData'
import users from './modules/users'
import stockItems from './modules/stockItems'
import salesOrders from './modules/salesOrders'
import statuses from './modules/statuses'
import products from './modules/products'
import purchaseOrderEditor from './modules/purchaseOrderEditor'
import purchaseOrders from './modules/purchaseOrders'
import inventoryProducts from './modules/inventoryProducts'
import purchaseReceiveDialog from './modules/purchaseReceiveDialog'
import inventoryAdjustmentEditor from './modules/inventoryAdjustmentEditor'
import inventoryAdjustment from './modules/inventoryAdjustment'
import reservationEditor from './modules/reservationEditor'
import reservations from './modules/reservations'
import genericDashboards from './modules/genericDashboards'
import dashboardDialog from './modules/dashboardDialog'
import invoices from './modules/invoices'
import invoiceEditor from './modules/invoiceEditor'
import customerEditor from './modules/customerEditor'
import inventory from './modules/inventory'
import customers from './modules/customers'
import customerInvoices from './modules/customerInvoices'
import creditNotes from './modules/creditNotes'
import cmsProviders from './modules/cmsProviders'
import cmsProducts from './modules/cmsProducts'
import i18n from '../i18n';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	state: {
		layout: {
			navPos: 'left', //top, bottom, left, right, false
			toolbar: 'top', //top, bottom, false
			footer: true, //above, below, false
			boxed: false, //true, false
			roundedCorners: false, //true, false
			viewAnimation: 'fade' // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
		},
		splashScreen: true,
		logged: true,
    	locale: process.env.VUE_APP_DEFAULT_LANGUAGE,
		flag: 'fr',
	},
	mutations: {
		setLayout(state, payload) {
			if(payload && payload.navPos !== undefined)
				state.layout.navPos = payload.navPos

			if(payload && payload.toolbar !== undefined)
				state.layout.toolbar = payload.toolbar

			if(payload && payload.footer !== undefined)
				state.layout.footer = payload.footer

			if(payload && payload.boxed !== undefined)
				state.layout.boxed = payload.boxed

			if(payload && payload.roundedCorners !== undefined)
				state.layout.roundedCorners = payload.roundedCorners

			if(payload && payload.viewAnimation !== undefined)
				state.layout.viewAnimation = payload.viewAnimation
		},
		setSplashScreen(state, payload) {
			state.splashScreen = payload
		},
    SET_LOCALE(state, locale) {
	  if (locale.substring(0,2) === 'fr') {
		state.flag = 'fr';
	  } else {
		state.flag = 'us';
	  }
      state.locale = locale;
    }
	},
	actions: {
    changeLocale({ commit }, locale) {
	  if (locale !== 'fr-CA' && locale !== 'en-US') {
		locale = 'fr-CA';
	  }
	  i18n.locale = locale.substring(0,2);
	  axios.defaults.headers.common['accept-language'] = locale;
	  moment.locale(locale.substring(0,2));
      commit('SET_LOCALE', locale);
    }
	},
	getters: {
		layout(state, getters) {
			return state.layout
		},
		navPos(state, getters) {
			return state.layout.navPos
		},
		toolbar(state, getters) {
			return state.layout.toolbar
		},
		footer(state, getters) {
			return state.layout.footer
		},
		boxed(state, getters) {
			return state.layout.boxed
		},
		roundedCorners(state, getters) {
			return state.layout.roundedCorners
		},
		viewAnimation(state, getters) {
			return state.layout.viewAnimation
		},
		isLogged(state, getters) {
			return state.logged
		},
		splashScreen(state, getters) {
			return state.splashScreen
		},
    getLocale (state, getters) {
      return state.locale;
    }
	},
	plugins: [createPersistedState({paths: ['layout']})],
	strict: debug,
	modules : {
		auth,
		customers,
		contacts,
		// OldPurchaseOrders,
		salesOrderEditor,
		controlData,
		users,
		stockItems,
		salesOrders,
		statuses,
		products,
		purchaseOrderEditor,
		purchaseOrders,
		inventoryProducts,
		purchaseReceiveDialog,
		inventoryAdjustmentEditor,
		inventoryAdjustment,
		reservationEditor,
		reservations,
		genericDashboards,
		dashboardDialog,
		invoices,
		invoiceEditor,
		customerEditor,
		inventory,
		customerInvoices,
		creditNotes,
		cmsProviders,
		cmsProducts
	}
});



httpUtils.setStore(store);

export default store;
